import React from 'react';
import css from './ReturnPolicy.module.css';
import NamedLink from '../../NamedLink/NamedLink';

const ReturnPolicy = () => {
  return (
    <div className={css.content}>
      <div className={css.section1}>
        <h2>Rückerstattungsrichtlinie von kitts</h2>
        <p>
          Beim Kauf von anderen Verbrauchern findet das Verbraucherschutzgesetz
          keine Anwendung. Das bedeutet insbesondere,
          Das bedeutet insbesondere, dass weder das Widerrufsrecht
          nach{" "}
          <a
            href="https://www.gesetze-im-internet.de/bgb/index.html#BJNR001950896BJNE261805360"
            target="_blank"
            className={css.customLink}
          >
            §§ 355 ff. BGB
          </a>
          {" "}noch die zweijährigen gesetzlichen Gewährleistungsrechte,
          wie sie im EU-Recht vereinheitlicht sind, gelten. Es finden die allgemeinen
          gesetzlichen Gewährleistungsrechte Anwendung, einschließlich der
          Gewährleistung für versteckte Mängel gemäß §§ 433 ff. BGB (sofern diese nicht
          vom Verkäufer ausgeschlossen wurden). Die Ansprüche des Käufers bei einem
          Mangel am Artikel ergeben sich aus § 437 BGB. Jede Bestellung, die über den
          „Kaufen"-Button aufgegeben wird, ist durch unseren{" "}

          <NamedLink
            name="AboutUsPage"
            to={{ hash: '#guarantee' }}
            className={css.customLink2}
          >
            Käuferschutz
          </NamedLink>

          {" "}abgedeckt.
        </p>
      </div>

      <div>
        <h3>
          1. Käuferschutz
        </h3>

        <p>
          Für jede Bestellung, die über den „Kaufen"-Button auf kitts aufgegeben wird,
          gilt der kitts Käuferschutz. Die Zahlung wird nach dem Kauf treuhänderisch
          verwahrt und erst an den Verkäufer freigegeben, wenn die Bestellung
          erfolgreich abgeschlossen wurde. Dank dem kitts Käuferschutz erhältst du eine
          Rückerstattung, wenn:
        </p>

        <ul>
          <li>1. deine Sendung nie ankommt,  </li>
          <li>2. deine Sendung während des Versands beschädigt wurde,  </li>
          <li>3. dein Trikot deutlich anders als beschrieben ist.</li>
        </ul>

        <p>
          Trikots, die dir nicht passen oder nicht gefallen, werden von den
          Rückerstattungsrichtlinien nicht abgedeckt. In diesem Fall kannst du den
          Verkäufer persönlich nach einer Rückgabe fragen. Es ist jedoch allein seine
          Entscheidung, ob er deiner Bitte nachkommt.
        </p>
      </div>

      <div>
        <h3>2. Was bedeutet „deutlich anders als beschrieben"?  </h3>
        <p>
          Ein Trikot gilt als „deutlich anders als beschrieben", wenn es nicht mit der
          Beschreibung oder den Fotos im Listing übereinstimmt. Das ist in der Regel bei
          folgenden Fällen gegeben:
        </p>

        <div className={css.listContainer}>
          <ul>
            <li>die falsche Größe,</li>
            <li>der falsche Verein, das falsche Land oder die falsche Saison,</li>
            <li>das falsche Design (z. B. Heim- statt Auswärtstrikot),  </li>
            <li>die falsche Farbe,  </li>
            <li>fehlende oder falsche Beflockung (Name, Nummer, Patches), obwohl im
              Listing anders angegeben,</li>
            <li>Beschädigungen, Flecken oder Mängel, die weder in der Beschreibung
              noch auf den Fotos erkennbar waren,  </li>
            <li>es handelt sich um eine Fälschung, </li>
            <li>der falsche Artikel wurde geliefert.  </li>
          </ul>
        </div>

        <div className={css.listContainer}>
          <p className={css.nichtListTitle}>
            <strong>Nicht</strong> als „deutlich anders als beschrieben" gelten in der Regel:
          </p>
          <ul>
            <li>geringfügige Gebrauchsspuren, die bei Secondhand-Trikots üblich sind
              und in der Beschreibung als solche angegeben wurden,  </li>
            <li>minimale Farbabweichungen, die auf unterschiedliche
              Bildschirmdarstellungen zurückzuführen sind,  </li>
            <li>subjektive Einschätzungen zur Passform oder zum Material, sofern
              Größe und Zustand korrekt angegeben waren.  </li>
          </ul>
        </div>
      </div>

      <div>
        <h3>3. Rückerstattungsarten</h3>
        <h4>Vollständige Rückerstattung:</h4>
        <p>
          Du erhältst eine vollständige Rückerstattung, wenn deine Bestellung storniert
          wird, bevor der Verkäufer das Trikot verschickt hat, oder wenn nach Prüfung
          durch kitts festgestellt wird, dass ein berechtigter Grund gemäß dieser
          Richtlinie vorliegt. Die vollständige Rückerstattung umfasst den Kaufpreis des
          Trikots sowie die vom Käufer bezahlten Versandkosten.
        </p>
      </div>

      <div>
        <h3>4. Problem melden – Frist und Ablauf</h3>
        <p>
          Ab dem Zeitpunkt, an dem der Verkäufer den Versand bestätigt hat, hast du{" "}
          <strong>
            14 Tage Zeit, um ein Problem zu melden
          </strong> und gegebenenfalls eine
          Rückerstattung zu beantragen. So funktioniert's:
        </p>
        <div className={css.problemList}>
          <ul>
            <li>1. Gehe zu deiner Bestellung in deinem Konto</li>
            <li>2. Wähle „Problem melden“ und beschreibe den Grund ausführlich</li>
          </ul>
        </div>

        <p>
          Die Frist von 14 Tagen gilt für alle Fälle, die unter die oben beschriebenen
          Rückerstattungsrichtlinien fallen. Solltest du das Problem nicht innerhalb
          dieser Frist melden, wird die Bestellung abgeschlossen und die Zahlung an den
          Verkäufer freigegeben.
        </p>
      </div>

      <div>
        <div>
          <h3>5. Nach der Meldung eines Problems</h3>
          <p>Nach der Meldung eines Problems läuft der Prozess wie folgt:</p>
        </div>
        <div className={css.listContainer}>
          <ul>
            <li>Die Bestellung wird zeitweise unterbrochen.</li>
            <li>Die Zahlung wird weiterhin sicher von unserem Zahlungsanbieter
              verwahrt, bis eine Lösung gefunden wurde.</li>
            <li>kitts prüft den Fall anhand des Listings, der Beschreibung, der Fotos und
              der vom Käufer eingereichten Nachweise.</li>
            <li>Käufer und Verkäufer haben die Möglichkeit, sich untereinander auf
              eine Lösung zu einigen (z. B. Teilrückerstattung, Rückgabe).  </li>
            <li>Kommt keine Einigung zustande, trifft kitts eine abschließende
              Entscheidung auf Grundlage der vorliegenden Informationen.  </li>
          </ul>
        </div>
      </div>


      <div>
        <h3>6. Rücksendung des Trikots</h3>
        <p>
          Wird eine vollständige Rückerstattung gewährt, kann kitts den Käufer
          auffordern, das Trikot an den Verkäufer zurückzusenden. War das Trikot
          tatsächlich deutlich anders als beschrieben, trägt in der Regel der Verkäufer
          die Rücksendekosten. Das Trikot muss in dem Zustand zurückgesendet
          werden, in dem es empfangen wurde.
        </p>
      </div>

      <div><h3>7. Auszahlung der Rückerstattung</h3>
        <p>
          Die Rückerstattung erfolgt über die ursprüngliche Zahlungsmethode. Die
          Bearbeitungszeit kann je nach Zahlungsanbieter variieren.
        </p></div>

      <div><h3>8. Missbrauch des Käuferschutzes</h3>
        <p>
          kitts behält sich vor, den Käuferschutz einzuschränken oder Konten zu
          sperren, wenn der begründete Verdacht besteht, dass der Käuferschutz
          missbräuchlich genutzt wird.
        </p></div>

      <div><h3>9. Kontakt</h3>
        <p>
          Bei Fragen zur Rückerstattungsrichtlinie oder bei Problemen mit einer
          Bestellung wende dich über unsere Kontaktseite an das kitts-Team.
        </p>
      </div>
    </div>
  );
};

export default ReturnPolicy;